<template>
  <div>
    <div class="col-6 form-group">
      <ValidationProvider v-slot="{ errors }" :name="'Title'">
        <label class="form-label" for="title">Title</label>
        <input v-model="localData.title" id="title" :name="'title'" class="form-input" type="text">
        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>

    <div class="col-6 form-group">
      <ValidationProvider name="Document" :rules="fileRules()" v-slot="{ errors, validate }">
        <label class="form-label" for="document">Document</label>
        <input id="document" name="document" type="file" class="form-input requiredField"
          @change="e => { handleFileUpload(e); validate(); }" />
        <div v-if="errors.length" class="vvERROR">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>

    <div class="col-6 form-group">
      <ValidationProvider v-slot="{ errors }" :name="'URL'">
        <label class="form-label mb-1" for="title">Optionally, you can provide a URL to the document instead of
          uploading the file.</label>
        <input v-model="localData.link" id="link" :name="'link'" class="form-input" type="text">
        <div v-if="localData.link"><span>Document URL link: </span><a :href="localData.link">{{ localData.link }}</a>
        </div>
        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>

    <div class="col-6 form-group">
      <ValidationProvider rules="required" v-slot="{ errors }" :name="'Description'">
        <label class="form-label" for="description">Description</label>
        <textarea id="description" name="description" v-model="localData.description"
          class="form-input requiredField"></textarea>
        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>

    <div class="col-3 form-group">
      <label class="col-lg-8 cardLabel font-weight-bold" for="company_required">Company Required</label>
      <BootstrapToggle v-model="localData.company_required" id="company_required" name="company_required"
        :options="{ on: 'Yes', off: 'No' }" />
    </div>

    <div class="col-3 form-group">
      <label class="col-lg-8 cardLabel font-weight-bold" for="worker_required">Worker Required</label>
      <BootstrapToggle v-model="localData.worker_required" id="worker_required" name="worker_required"
        :options="{ on: 'Yes', off: 'No' }" />
    </div>

    <div class="col-4 mt-2">
      <button v-if="localData.order_job_id > 0" type="button" class="btn btn-primary" @click="saveRam()">Save</button>
      <button type="button" class="btn btn-danger btn-sm text-white" @click="deleteRam()">Remove</button>
    </div>

    <hr>

  </div>

</template>
<script>
import BootstrapToggle from 'vue-bootstrap-toggle';
export default {
  name: 'ram',
  components: { BootstrapToggle },
  props: {
    data: {
      type: Object,
      required: true,
      default() {
        return {
          order_job_id: 0,
          title: null,
          description: null,
          company_required: true,
          worker_required: true,
          link: null,
          file: null
        };
      }
    }
  },
  data() {
    return {
      localData: this.data
    }
  },
  methods: {
    fileRules() {
      return {
        required: false,
        ext: ['pdf'],
        size: 10240
      };
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.localData.file = file;
    },
    getRam() {
      if (this.localData.id > 0) {
        axios.get(this.crmApiPathV2 + 'common/declarations/order/' + this.localData.id).then(ram => {
          this.localData = ram.data.data;
        });
      }
    },
    saveRam() {
      // create
      if (!this.localData.id || this.localData.id === 0) {
        var url = this.crmApiPathV2 + 'common/declarations';
      } else {
        // update
        var url = this.crmApiPathV2 + 'common/declarations/order/' + this.localData.id;
      }

      this.sendFormData(url);
    },
    deleteRam() {
      if (this.localData.id > 0) {
        axios.delete(this.crmApiPathV2 + 'common/declarations/order/' + this.localData.id);
        this.$snotify.warning('Declaration deleted!');
      }
      this.$emit('remove-ram', this.localData.id);
    },
    sendFormData(url) {
      const formData = new FormData();
      formData.append('order_job_id', this.localData.order_job_id);
      formData.append('title', this.localData.title);
      formData.append('description', this.localData.description);
      formData.append('company_required', this.localData.company_required ? '1' : '0');
      formData.append('worker_required', this.localData.worker_required ? '1' : '0');

      if(this.localData.link) {
          formData.append('link', this.localData.link);
      }
      
      if(this.localData.file) {
          formData.append('file', this.localData.file);
      }
      
      axios.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then(response => {
        this.localData = response.data.data;
        this.$snotify.success('Declaration saved!');
      }).catch(error => {
        if (error.response.data.errors) {
          let message = '';
          Object.values(error.response.data.errors).forEach(errorArray => {
            errorArray.forEach(errorMessage => {
              message += errorMessage;
            });
          });
          this.$snotify.error(message);
        } else {
          this.$snotify.error('Unknown error occurred.');
        }
      });
    },
  },
  created() {
    this.getRam();
  }
}
</script>
